import React from 'react';
import HeroSection from '../components/hero/HeroSection';
import LatestRelease from '../components/sections/LatestRelease';
import UpcomingReleases from '../components/sections/UpcomingReleases';

const Home = () => {
    return (
        <div>
            <HeroSection />
            <LatestRelease />
            <UpcomingReleases />
        </div>
    );
};

export default Home;